import { Link } from "react-router-dom";
import {
  ACCEPTANCE_FOOTNOTE,
  CHECKBOX_CLAUSES_TEXT,
  CONTRACT_VERSION,
  LEGAL_LINKS,
  LEGAL_LABELS,
} from "../config/legalVersions";

export default function LegalAcceptanceForm({
  values,
  onChange,
  errors = {},
  compact = false,
}) {
  const wrapperClass = compact
    ? "rounded-xl border border-slate-200 bg-slate-50/80 p-4 space-y-3"
    : "rounded-xl border border-slate-200 bg-slate-50/80 p-4 space-y-3";

  return (
    <div className={wrapperClass}>
      <p className="text-xs font-medium uppercase tracking-wide text-slate-500">
        Accettazione contrattuale
      </p>

      <label className="flex items-start gap-2.5 text-sm text-slate-700 leading-relaxed">
        <input
          type="checkbox"
          checked={values.acceptedTerms}
          onChange={(e) => onChange("acceptedTerms", e.target.checked)}
          className={`mt-0.5 h-4 w-4 shrink-0 rounded border-slate-300 text-emerald-600 focus:ring-emerald-500 ${
            errors.acceptedTerms ? "border-red-500" : ""
          }`}
        />
        <span>
          Ho letto e accetto i{" "}
          <a
            href={LEGAL_LINKS.contract}
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-emerald-700 hover:underline"
          >
            {LEGAL_LABELS.contract}
          </a>
          , la{" "}
          <Link to={LEGAL_LINKS.privacy} target="_blank" className="font-medium text-emerald-700 hover:underline">
            {LEGAL_LABELS.privacy}
          </Link>
          , la{" "}
          <Link to={LEGAL_LINKS.cookies} target="_blank" className="font-medium text-emerald-700 hover:underline">
            {LEGAL_LABELS.cookies}
          </Link>
          {" "}e l'
          <Link to={LEGAL_LINKS.terms} target="_blank" className="font-medium text-emerald-700 hover:underline">
            {LEGAL_LABELS.dpa}
          </Link>
          , ove applicabile. <span className="text-red-500">*</span>
        </span>
      </label>
      {errors.acceptedTerms && (
        <p className="text-sm text-red-500">{errors.acceptedTerms}</p>
      )}

      <label className="flex items-start gap-2.5 text-sm text-slate-700 leading-relaxed">
        <input
          type="checkbox"
          checked={values.acceptedClauses1341}
          onChange={(e) => onChange("acceptedClauses1341", e.target.checked)}
          className={`mt-0.5 h-4 w-4 shrink-0 rounded border-slate-300 text-emerald-600 focus:ring-emerald-500 ${
            errors.acceptedClauses1341 ? "border-red-500" : ""
          }`}
        />
        <span>
          {CHECKBOX_CLAUSES_TEXT} <span className="text-red-500">*</span>
        </span>
      </label>
      {errors.acceptedClauses1341 && (
        <p className="text-sm text-red-500">{errors.acceptedClauses1341}</p>
      )}

      <p className="text-xs text-slate-500">Versione contratto: {CONTRACT_VERSION}</p>
      <p className="text-xs text-slate-500 leading-relaxed">{ACCEPTANCE_FOOTNOTE}</p>
    </div>
  );
}
